import { atomWithReset } from 'jotai/utils';

export const interviewTime = atomWithReset<string>('00:00:00');
